import useVersionCheck from '@/src/hooks/useVersionCheck';
import { useEffect, useState } from 'react';

export const useModalUpdatePageMessage = () => {
    //--------------------------------------
    const [isRefreshing, setIsRefreshing] = useState(true);
    useEffect(() => {
        setIsRefreshing(false);
    }, []);
    //--------------------------------------
    const { isOutdated, latestVersion } = useVersionCheck();
    //--------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    //--------------------------------------
    useEffect(() => {
        if (isOutdated === true) {
            setIsOpen(true);
        }
    }, [isOutdated]);
    //--------------------------------------
    const handleOpen = () => {
        setIsOpen(true);
    };
    const handleClose = () => {
        setIsOpen(false);
    };
    //--------------------------------------
    return {
        isRefreshing,
        isOutdated,
        latestVersion,
        isOpen,
        handleOpen,
        handleClose,
    };
    //--------------------------------------
};
